(() => {
  const VIEW_DELAY_MS = 800;
  const EVENT_TTL_MS = 24 * 60 * 60 * 1000;
  const containers = [...document.querySelectorAll('[data-inkybox-social-proof]')];
  if (!containers.length) return;

  const createClientId = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    window.crypto?.getRandomValues?.(bytes);
    return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('') ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  };

  const getClientId = () => {
    if (window.__inkyboxSocialProofClientId) return window.__inkyboxSocialProofClientId;
    try {
      const key = 'inkybox_social_proof_visitor';
      let value = window.localStorage.getItem(key);
      if (!value) {
        value = createClientId();
        window.localStorage.setItem(key, value);
      }
      window.__inkyboxSocialProofClientId = value;
    } catch (_error) {
      window.__inkyboxSocialProofClientId = createClientId();
    }
    return window.__inkyboxSocialProofClientId;
  };

  const getConfig = (container) => {
    const productId = String(container.dataset.productId || '').trim();
    const endpointValue = String(container.dataset.apiEndpoint || '').trim().replace(/\/$/, '');
    if (!/^\d+$/.test(productId) || !endpointValue) return null;
    try {
      const endpoint = new URL(endpointValue);
      if (endpoint.protocol !== 'https:') return null;
      return { productId, endpoint: endpoint.href.replace(/\/$/, '') };
    } catch (_error) {
      return null;
    }
  };

  const postEvent = async (container, path) => {
    const config = getConfig(container);
    if (!config) return null;
    const response = await fetch(`${config.endpoint}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: config.productId, clientId: getClientId() }),
      credentials: 'omit',
      keepalive: true,
    });
    if (!response.ok) return null;
    return response.json();
  };

  const renderScore = (container, payload) => {
    const item = container.querySelector('[data-inkybox-demand-item]');
    const output = container.querySelector('[data-inkybox-demand-score]');
    const scoreCopy = container.querySelector('[data-inkybox-demand-score-copy]');
    const emptyCopy = container.querySelector('[data-inkybox-demand-empty-copy]');
    const rawScore = Number(payload?.score);
    if (!item || !output || !scoreCopy || !emptyCopy || !Number.isFinite(rawScore)) return;
    const score = Math.max(0, Math.floor(rawScore));
    const minimum = Math.max(1, Number(container.dataset.minimumScore) || 1);

    if (score === 0) {
      scoreCopy.hidden = true;
      emptyCopy.hidden = false;
      item.hidden = !emptyCopy.textContent.trim();
      return;
    }

    if (score < minimum) {
      item.hidden = true;
      return;
    }

    output.textContent = score.toLocaleString('en-US');
    scoreCopy.hidden = false;
    emptyCopy.hidden = true;
    item.hidden = false;
  };

  const recordView = (container) => {
    if (navigator.webdriver) return;
    postEvent(container, '/events/product-view')
      .then((payload) => renderScore(container, payload))
      .catch(() => {});
  };

  const scheduleView = (container) => {
    const run = () => window.setTimeout(() => recordView(container), VIEW_DELAY_MS);
    if (document.visibilityState === 'visible') {
      run();
      return;
    }
    document.addEventListener('visibilitychange', function handleVisibility() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', handleVisibility);
      run();
    });
  };

  const wasRecentlySent = (productId) => {
    try {
      return Date.now() - Number(window.localStorage.getItem(`inkybox_social_proof_cart_${productId}`) || 0) < EVENT_TTL_MS;
    } catch (_error) {
      return false;
    }
  };

  const rememberSent = (productId) => {
    try {
      window.localStorage.setItem(`inkybox_social_proof_cart_${productId}`, String(Date.now()));
    } catch (_error) {}
  };

  const recordCartAdd = (productId) => {
    const container = containers.find((item) => item.dataset.productId === String(productId || ''));
    if (!container || wasRecentlySent(container.dataset.productId)) return;
    postEvent(container, '/events/cart-add')
      .then((payload) => {
        if (payload) rememberSent(container.dataset.productId);
      })
      .catch(() => {});
  };

  containers.forEach(scheduleView);

  document.addEventListener('inkybox:cart-add-success', (event) => {
    recordCartAdd(event.detail?.productId);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') return;
      recordCartAdd(containers[0]?.dataset.productId);
    });
  }
})();
